export default {};
throw new Error(`Could not resolve "gl-matrix" imported by "@appletosolutions/reactbits". Is it installed?`)